import React from 'react';
import { Alert as BootstrapAlert } from 'react-bootstrap';

const Alert = ({ variant, message, onClose, dismissible = true }) => {
  return (
    <BootstrapAlert 
      variant={variant} 
      onClose={onClose} 
      dismissible={dismissible}
    >
      {message}
    </BootstrapAlert>
  );
};

export default Alert;